import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import FAQService from '../../../services/FAQService';
import Results from './Results';
import Toolbar from './Toolbar';

import { selector as UserSelector } from '../../../redux/ducks/user';

const useStyles = makeStyles((theme) => ({
  categoryTitle: {
    display: 'inline-block',
    marginRight: '1rem'
  },
  titleEditable: {
    fontSize: '2.18rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    lineHeight: 1.167,
    letterSpacing: '-0.24px',
    color: '#888',
    marginBottom: '.5rem',
  },
  saveIcon: {
    color: 'white',
  },
  editButton: {
    cursor: 'pointer'
  },
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const FAQView = () => {
  const classes = useStyles();
  const { user } = useSelector(UserSelector);
  const [faq, setFaq] = useState([]);

  const getFAQ = async () => {
    const response = await FAQService.getAll();

    if (response?.code === 200 && response?.data?.length > 0) {
      setFaq(response?.data);
    }
  };

  const refresh = async () => {
    if (user?.id) {
      await getFAQ();
    }
  };

  useEffect(() => {
    if (user?.id) {
      getFAQ();
    }
  }, [user]);

  return (
    <Page
      className={classes.root}
      title="Preguntas Frecuentes"
    >
      <Container maxWidth={false}>
        <Toolbar refresh={refresh} />
        <Box mt={3}>
          <Results data={faq} onRefresh={refresh} />
        </Box>
      </Container>
    </Page>
  );
};

export default FAQView;
